var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailsvgrepocom31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 9.35714V4.21429C11.7143 4.21429 6.51428 7.84286 6.00856 8.03114C5.51142 7.85143 0.285706 4.21429 0.285706 4.21429V9.35714C0.285706 10.0714 0.437134 10.2143 1.14285 10.2143H10.8571C11.5797 10.2143 11.7143 10.0889 11.7143 9.35714ZM11.706 3.206C11.706 2.68571 11.5543 2.5 10.8571 2.5H1.14285C0.425706 2.5 0.285706 2.72286 0.285706 3.24286L0.294277 3.32286C0.294277 3.32286 5.45685 6.87714 6.00856 7.07143C6.59142 6.84571 11.7143 3.24286 11.7143 3.24286L11.706 3.206Z",
    fill: "#169C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsvgrepocom31);
export default __webpack_public_path__ + "static/media/emailsvgrepocom-3-1.ac459cfdd54611fd979b72a4de988068.svg";
export { ForwardRef as ReactComponent };